(function () {
  'use strict';

  var FALLBACK = [
    'https://hhcnewapp.blr1.cdn.digitaloceanspaces.com/uploads/2026/10/09/e757d753bc2917ec4a6d4bf032f916f6.jpeg',
    'https://hhcnewapp.blr1.cdn.digitaloceanspaces.com/uploads/2026/10/10/8044f971aae345e4c30382ab6c33de4b.jpeg',
    'https://hhcnewapp.blr1.cdn.digitaloceanspaces.com/uploads/2026/10/10/af70118ae2370a264f0c170d4b30d8db.jpeg',
    'https://hhcnewapp.blr1.cdn.digitaloceanspaces.com/uploads/2026/10/09/edce25a35d8885ee020c466543d433fb.jpeg',
    'https://hhcnewapp.blr1.cdn.digitaloceanspaces.com/uploads/2026/10/07/151ae45fa3f5c2342c98184bf965cd20.jpeg',
    'https://hhcnewapp.blr1.cdn.digitaloceanspaces.com/uploads/2026/10/07/201f9260d2ab3cdfe1d12e814f788ff7.jpeg',
    'https://hhcnewapp.blr1.cdn.digitaloceanspaces.com/uploads/2026/10/07/7a2b4bec57461de6d44e0589984c2821.jpeg',
    'https://hhcnewapp.blr1.cdn.digitaloceanspaces.com/uploads/2026/10/07/bc329282e9452a88e21e836c795311dd.jpeg',
    'https://hhcnewapp.blr1.cdn.digitaloceanspaces.com/uploads/2026/10/07/dc93e3713cb3af8ee487e1669513d086.jpeg',
    'https://hhcnewapp.blr1.cdn.digitaloceanspaces.com/uploads/2026/10/07/cbd0fa806d7208413e7afc65f5a4bcac.jpeg',
    'https://hhcnewapp.blr1.cdn.digitaloceanspaces.com/uploads/2026/10/09/8c281f74b7f25ec0129cab9f79b7cb94.jpeg',
    'https://hhcnewapp.blr1.cdn.digitaloceanspaces.com/uploads/2026/10/09/0e3c8f01839a11a40aad9413660b148e.jpeg'
  ];

  var STATUSES = [
    ['Limited Stock', '#d9232d'],
    ['Pre Order Now', '#7c3aed'],
    ['Ultra AMOLED', '#d9232d'],
    ['Premium Smartwatch', '#7c3aed'],
    ['AMOLED Display', '#d9232d'],
    ['Best Seller', '#0d0d0d'],
    ['New Arrival', '#16a34a'],
    ['Hot Deal', '#ea580c'],
    ["Editor's Pick", '#2563eb']
  ];

  var TAGLINES = [
    '1.38" HD Display | Zinc Alloy Frame',
    'Most Popular \uD83D\uDD25',
    'Up to 9 Days Battery',
    'AMOLED Display | 7-Day Battery',
    'Stainless Steel Strap',
    'Bluetooth Calling | SpO2',
    'Water Resistant | 5ATM',
    'Crystal Clear Display',
    'Feather Light | 32g',
    'Premium Smartwatch',
    'Sapphire Glass | Steel Body'
  ];

  var KEYWORD_TAGS = [
    ['arabic', 'Arabic Dial | Stainless Steel'],
    ['rolex', 'Luxury Inspired Design'],
    ['patek', 'Premium Inspired Design'],
    ['chronograph', 'Chronograph | Water Resistant'],
    ['leather', 'Genuine Leather Strap'],
    ['smart', 'AMOLED Display | Fitness Tracking'],
    ['gold', 'Gold Plated | Luxury Finish'],
    ['skeleton', 'Skeleton Dial | Auto Movement'],
    ['women', 'Elegant Design | Crystal Accents'],
    ['silicone', 'Sport Band | Sweat Proof'],
    ['quartz', 'Precision Quartz | Steel Body'],
    ['steel', 'Stainless Steel | 5ATM']
  ];

  var fallbackIdx = 0;

  function hashStr(s) {
    var h = 2166136261;
    for (var i = 0; i < s.length; i++) {
      h ^= s.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  }

  function mulberry32(a) {
    return function () {
      a |= 0;
      a = (a + 0x6d2b79f5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function parseMoney(s) {
    if (!s) return 0;
    var m = String(s).match(/[0-9][0-9,]*(?:\.[0-9]+)?/g);
    if (!m) return 0;
    var n = parseFloat(m[m.length - 1].replace(/,/g, ''));
    return isNaN(n) ? 0 : n;
  }

  function fmtMoney(n) {
    return 'Rs\u00A0' + Math.round(n).toLocaleString('en-US');
  }

  function isBrokenImg(img) {
    var src = img.currentSrc || img.src || '';
    if (!src) return true;
    if (/placeholder|no[_-]?image|product[_-]?placeholder/i.test(src)) return true;
    if (img.complete && img.naturalWidth === 0) return true;
    return false;
  }

  function swapFallback(img) {
    var seed = hashStr(img.getAttribute('alt') || img.src || String(fallbackIdx++));
    img.setAttribute('data-hfb', '1');
    img.removeAttribute('srcset');
    img.src = FALLBACK[Math.abs(seed) % FALLBACK.length];
  }

  document.addEventListener(
    'error',
    function (e) {
      var img = e.target;
      if (!img || img.tagName !== 'IMG' || img.getAttribute('data-hfb')) return;
      try {
        swapFallback(img);
      } catch (err) { /* noop */ }
    },
    true
  );

  function taglineFor(title, rng) {
    var t = (title || '').toLowerCase();
    for (var i = 0; i < KEYWORD_TAGS.length; i++) {
      if (t.indexOf(KEYWORD_TAGS[i][0]) !== -1) return KEYWORD_TAGS[i][1];
    }
    return TAGLINES[Math.floor(rng() * TAGLINES.length)];
  }

  function statsFor(handle, title) {
    try {
      if (window.HorizonSocial && typeof window.HorizonSocial.reviewStats === 'function') {
        return window.HorizonSocial.reviewStats(handle, title);
      }
    } catch (e) { /* noop */ }
    return null;
  }

  function ratingHTML(avg, count, rng) {
    var val = avg ? avg.toFixed(2) : (4 + rng() * 0.95).toFixed(2);
    var n = count || (18 + Math.floor(rng() * 360));
    return '<span class="hcard__rating"><span class="hcard__star on">\u2605</span><b>' + val + '</b><i>(' + n + ')</i></span>';
  }

  var COLOR_HEX = {
    'black': '#151515',
    'black strap': '#151515',
    'white': '#f4f2ee',
    'green': '#2f7d4d',
    'red': '#c0392b',
    'blue': '#2f5fd0',
    'sky blue': '#7ec8e3',
    'light blue': '#9cc7e8',
    'pink': '#e8a1b4',
    'rose': '#e0a899',
    'rose gold': '#e0a899',
    'gold': '#d9b65d',
    'golden': '#d9b65d',
    'grey': '#9a9a9a',
    'gray': '#9a9a9a',
    'silver': '#c9ccd1',
    'yellow': '#e8c84a',
    'brown': '#6f4427',
    'dark brown': '#4a2e19',
    'brown strap': '#6f4427',
    'orange': '#e07b39',
    'purple': '#7c3aed',
    'navy': '#1e2f5c',
    'beige': '#d9cbb8',
    'cream': '#efe9dc'
  };

  function normColor(v) {
    return String(v || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  function colorOptionIndex(product) {
    var opts = product.options || [];
    for (var i = 0; i < opts.length; i++) {
      if (/colou?r/i.test(opts[i])) return i;
    }
    if (opts.length === 1 && opts[0] && opts[0] !== 'Title') return 0;
    return -1;
  }

  function loadSwatches(handle, container) {
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('bad response');
        return r.json();
      })
      .then(function (p) {
        var idx = colorOptionIndex(p);
        if (idx < 0) return;
        var vals = [];
        (p.variants || []).forEach(function (v) {
          var val = [v.option1, v.option2, v.option3][idx];
          var n = normColor(val);
          if (n && vals.indexOf(n) === -1) vals.push(n);
        });
        if (!vals.length) return;
        var show = Math.min(3, vals.length);
        var hidden = vals.length - show;
        var html = '';
        for (var i = 0; i < show; i++) {
          html += '<span class="hcard__sw" style="background:' + (COLOR_HEX[vals[i]] || '#8f8f8f') + '" title="' + vals[i].replace(/"/g, '') + '"></span>';
        }
        if (hidden > 0) html += '<span class="hcard__sw-more">+' + hidden + '</span>';
        container.innerHTML = html;
      })
      .catch(function () { /* no swatches */ });
  }

  function cleanPriceText(priceEl, cur) {
    if (!priceEl || !(cur >= 1)) return;
    var bdi = priceEl.querySelector('.price bdi');
    if (bdi) bdi.textContent = 'Rs.' + Math.round(cur).toLocaleString('en-US');
  }

  function fakeCompare(price, rng) {
    if (!(price >= 1)) return { mrp: 0, pct: 0 };
    var mult = 1.6 + rng() * 1.2;
    var mrp = Math.round((price * mult) / 10) * 10;
    if (mrp <= price) mrp = price + Math.round(price * 0.5);
    var pct = Math.round(((mrp - price) / mrp) * 100);
    return { mrp: mrp, pct: pct };
  }

  function enhanceCard(card) {
    if (card.getAttribute('data-hcard')) return;
    card.setAttribute('data-hcard', '1');

    try {
      var content = card.querySelector('.product-card__content');
      if (!content) return;

      var link = card.querySelector('a[href*="/products/"]');
      var href = link ? link.getAttribute('href') : '/collections/all';
      var handle = (href || '').split('?')[0].split('/').pop();
      var rng = mulberry32(hashStr(handle + '::v4'));

      var titleEl = null;
      var blocks = content.querySelectorAll('.text-block');
      for (var i = 0; i < blocks.length; i++) {
        var el = blocks[i];
        if (el.closest('product-price')) continue;
        if (el.querySelector('bdi')) continue;
        titleEl = el;
        break;
      }
      if (!titleEl) titleEl = content.querySelector('.rte');

      var priceEl = content.querySelector('product-price');
      var gallery = card.querySelector('.card-gallery') || card;

      var realSale = 0;
      var realCur = 0;
      var saleEl = null;
      if (priceEl) {
        saleEl = priceEl.querySelector('.compare-at-price bdi');
        var curEl = priceEl.querySelector('.price bdi') || priceEl.querySelector('.price');
        realSale = parseMoney(saleEl ? saleEl.textContent : '');
        realCur = parseMoney(curEl ? curEl.textContent : '');
        if (!realCur) realCur = parseMoney(priceEl.textContent);

        if (!(realSale > realCur && realCur > 0)) {
          var cAt = priceEl.querySelectorAll('.compare-at-price');
          for (var ci = 0; ci < cAt.length; ci++) cAt[ci].remove();
        }
        cleanPriceText(priceEl, realCur);
      }

      var mrp = 0;
      var pct = 0;
      if (realSale > realCur && realCur > 0) {
        mrp = realSale;
        pct = Math.round(((realSale - realCur) / realSale) * 100);
      } else if (realCur > 0) {
        var fc = fakeCompare(realCur, rng);
        mrp = fc.mrp;
        pct = fc.pct;
      }

      if (!card.querySelector('.hcard__status')) {
        var st = document.createElement('span');
        st.className = 'hcard__status';
        if (mrp > 0 && pct >= 15) {
          st.textContent = 'Was ' + fmtMoney(mrp);
          st.style.color = '#d9232d';
        } else {
          var pickS = STATUSES[Math.floor(rng() * STATUSES.length)];
          st.textContent = pickS[0];
          st.style.color = pickS[1];
        }
        if (gallery !== card && gallery.parentNode) {
          gallery.parentNode.insertBefore(st, gallery);
        } else {
          card.insertBefore(st, card.firstChild);
        }
      }

      if (titleEl && !content.querySelector('.hcard__titlerow')) {
        var row = document.createElement('div');
        row.className = 'hcard__titlerow';
        titleEl.parentNode.insertBefore(row, titleEl);
        row.appendChild(titleEl);
        if (pct > 0) {
          var off = document.createElement('span');
          off.className = 'hcard__off';
          off.textContent = pct + '% OFF';
          row.appendChild(off);
        }
        var tag = document.createElement('div');
        tag.className = 'hcard__tag';
        tag.textContent = taglineFor(titleEl.textContent, rng);
        row.parentNode.insertBefore(tag, row.nextSibling);
      }

      if (!content.querySelector('.hcard__meta')) {
        var meta = document.createElement('div');
        meta.className = 'hcard__meta';
        var anchor = content.querySelector('.hcard__tag') || content.querySelector('.hcard__titlerow');
        if (anchor && anchor.parentNode) {
          anchor.parentNode.insertBefore(meta, anchor.nextSibling);
        } else {
          content.appendChild(meta);
        }
        var sw = content.querySelector('product-swatches');
        if (sw && sw.querySelector('.variant-option__swatch')) {
          meta.appendChild(sw);
        } else {
          var swBox = document.createElement('span');
          swBox.className = 'hcard__swatches';
          meta.appendChild(swBox);
          loadSwatches(handle, swBox);
        }
        var tmp = document.createElement('span');
        var stRev = statsFor(handle, titleEl ? titleEl.textContent : '');
        tmp.innerHTML = stRev ? ratingHTML(stRev.avg, stRev.count, rng) : ratingHTML(null, null, rng);
        if (tmp.firstChild) meta.appendChild(tmp.firstChild);
      }

      if (priceEl && !content.querySelector('.hcard__buyrow')) {
        var buyrow = document.createElement('div');
        buyrow.className = 'hcard__buyrow';
        priceEl.parentNode.insertBefore(buyrow, priceEl);
        if (realSale === 0 && mrp > 0 && !priceEl.querySelector('.hcard__mrp')) {
          var mrpEl = document.createElement('span');
          mrpEl.className = 'hcard__mrp';
          mrpEl.textContent = fmtMoney(mrp);
          priceEl.insertBefore(mrpEl, priceEl.firstChild);
        }
        buyrow.appendChild(priceEl);
        var buy = document.createElement('a');
        buy.className = 'hcard__buy';
        buy.href = href || '/collections/all';
        buy.textContent = 'Buy Now';
        buyrow.appendChild(buy);
      }

      card.querySelectorAll('img').forEach(function (img) {
        if (isBrokenImg(img) && !img.getAttribute('data-hfb')) swapFallback(img);
      });
    } catch (err) {
      try {
        console.warn('hcard enhance failed', err);
      } catch (e2) { /* noop */ }
    }
  }

  function stylePDPVariants() {
    var boxes = document.querySelectorAll('.product-details fieldset.variant-option');
    boxes.forEach(function (fs) {
      if (fs.getAttribute('data-hpdp-swatch')) return;
      var legend = fs.querySelector('legend');
      var legendTxt = legend ? legend.textContent : '';
      if (!/colou?r/i.test(legendTxt)) return;
      var labels = fs.querySelectorAll('.variant-option__button-label');
      if (!labels.length) return;
      fs.setAttribute('data-hpdp-swatch', '1');
      fs.classList.add('hpdp--color');
      labels.forEach(function (lab) {
        var txt = (lab.textContent || '').trim();
        var n = normColor(txt);
        var hex = COLOR_HEX[txt] || (n && COLOR_HEX[n]) || '#9a9a9a';
        var dot = document.createElement('span');
        dot.className = 'hpdp__dot';
        dot.style.background = hex;
        lab.insertBefore(dot, lab.firstChild);
      });
      var mark = function () {
        labels.forEach(function (lab) {
          var inp = lab.querySelector('input');
          lab.classList.toggle('hpdp--sel', !!(inp && inp.checked));
        });
      };
      fs.addEventListener('change', mark);
      mark();
    });
  }

  function enhancePDP() {
    // Disabled: PDP extras now rendered by Liquid blocks (zero-pdp-extras, zpdp_* text blocks).
    return;
  }

  function enhanceAll() {
    document.querySelectorAll('.product-card, .product-grid__card').forEach(enhanceCard);
    document.querySelectorAll('.product-media img, img.product-media__image').forEach(function (img) {
      if (isBrokenImg(img) && !img.getAttribute('data-hfb')) {
        try {
          swapFallback(img);
        } catch (e) { /* noop */ }
      }
    });
    enhancePDP();
  }

  function boot() {
    enhanceAll();
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        enhanceAll();
      }).observe(document.body, { childList: true, subtree: true });
    }
    window.addEventListener('load', function () {
      document.querySelectorAll('img').forEach(function (img) {
        if (img.complete && img.naturalWidth === 0 && !img.getAttribute('data-hfb')) {
          try {
            swapFallback(img);
          } catch (e) { /* noop */ }
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
